import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function SocialNaverIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path fillRule="evenodd" clipRule="evenodd"
                d="M7.5 2.5C4.73858 2.5 2.5 4.73858 2.5 7.5V16.5C2.5 19.2614 4.73858 21.5 7.5 21.5H16.5C19.2614 21.5 21.5 19.2614 21.5 16.5V7.5C21.5 4.73858 19.2614 2.5 16.5 2.5H7.5ZM13.48 12.2927V7.84375H16.1562V16.1562H13.6017L10.52 11.7073V16.1562H7.84375V7.84375H10.3983L13.48 12.2927Z"
                fill={color}/>
        </svg>
    );
}

export default SocialNaverIcon;
